import useDiscard from "../../../useDiscard";
import useWeakMap from "../../../utils/useWeakMap";
import useWeakSet from "../../../utils/useWeakSet";
import useQueryOriginalSourceByLayer from "./useStoreOriginalSource";

const store = useWeakMap();
const cachingRoots = useWeakSet();

const onDiscardLayer = (layer) => {
    store.delete(layer);
    cachingRoots.delete(layer);
}

export const useMarkRootLayer = (layer, rootLayer) => {
    let root;
    if (!cachingRoots.has(rootLayer)) {
        rootLayer = useQueryRootLayer(rootLayer);
    }
    if (rootLayer && !store.has(layer)) {
        store.set(layer, rootLayer);
        useDiscard(layer, onDiscardLayer);
    }
}

export const useOverrideRootLayer = (layer, rootLayer) => {
    store.delete(layer);
    
    useMarkRootLayer(layer, rootLayer);
}

export const isRootLayer = (layer) => cachingRoots.has(layer);

export const storeRootLayer = (rootLayer) => {
    cachingRoots.add(rootLayer)
}


const useQueryRootLayer = (layer) => {
    return store.get(layer);
}

export default useQueryRootLayer;